module.exports = __webpack_public_path__ + "static/img/sellOut.21eb3215.png";